<template>
  <service-screen-layout :parts="parts" v-if="saleLoaded">
    <template v-slot:account>
      <div class="row row-spacing">
        <div class="col-md-8 py-4">
                  
          <div class="form-row">
            <div class="form-group col-md-6">
              <div class="input-group">
                <input v-model="saleDefinition.sale.description" type="text" class="form-control" disabled="" />
              </div>
            </div>
            <div class="form-group col-md-6 d-flex align-items-center">
              <label class="text-warning">This sale is for Over-Usage Billing only.</label>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <div class="input-group">
                Linked to Cloud Backup:&nbsp; 
                <span class="mr-2 blueLink" @click="viewSale(saleDefinition.sale.solarwindsOverUsage.backupSaleNumber)"> 
                  Sale #{{ saleDefinition.sale.solarwindsOverUsage.backupSaleNumber }}
                </span>      
              </div>
            </div>
          </div>

        </div>
      </div>
    </template>

  </service-screen-layout>
</template>

<script>
import SaleFunctions from "@/pages/Services/SaleFunctions";
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout"

export default {
  extends: 
    SaleFunctions,
  components: {
    ServiceScreenLayout
  },
  computed: {
    
  },
  data() {
    return {
      saleNumber: null,
      saleLoaded: false,
      parts: [
        {
          name: "account",
          icon: "fa fa-info-circle",
          displayName: "Sale Details",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        sale: {}
      },
    };
  },
  mounted() {
     this.saleNumber = this.$route.params.saleNumber;
     this.loadSaleDefinition();
  },
  methods: {
    loadSaleDefinition: function() {
      this.fetchSaleDefinition(this.saleNumber).then(
        (response) => {
          this.saleDefinition = response.data;         
          this.saleLoaded = true;
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Sale Definition", error);
        }
      );
    },
    saveSale: function() {      
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
          this.$validator.validateAll().then(result => {
            if (result) {
              const hostUrlV2 = this.$config.aimsAPIv2;
              const saleNumber = this.saleNumber;
              const solarwindsOverUsageSale = this.saleDefinition;
              this.$http.put(`${hostUrlV2}sales/definition/${saleNumber}/update`, solarwindsOverUsageSale).then(
                  (response) => {
                    this.showSuccess("Save Success");
                    this.loadSaleDefinition();
                  },
                  (error) => {
                    console.error(error);
                    this.showError("Error Saving sale", error);
                  }
                );
            }
          });
        }
      });
    },
    viewSale: function (saleNumber) {
      this.$http.get(this.$config.aimsAPI + "sales/" + saleNumber)
        .then(response => {
            const saleProduct = response.data.product;
            const saleClient = response.data.client
            const productRoute = this.getProductDefinition(saleProduct.productDefinition);

            if (productRoute == -1) {
                this.showWarning(
                    "Could not view sale #" + saleNumber,
                    "'" + saleProduct.description + "' is not supported yet."
                );
            } else {
                const { href } = this.$router.resolve({
                    name: productRoute.routeName,
                    params: {
                        clientNumber: saleClient.clientNumber,
                        saleNumber: saleNumber
                    }
                });
                window.open(href, '_blank');  
            }
        },
        error => {
            console.error(error);
            this.showError("Error Fetching Product for Sale", error);
        });
    },
  },
};
</script>

<style>
  .blueLink {
    color: #629EEB;
  }

  .blueLink:hover {
    cursor: pointer;
    color: #307fe6;
    text-decoration: underline;
  }
</style>